import { render, staticRenderFns } from "./addForumTool.vue?vue&type=template&id=be760016"
import script from "./addForumTool.vue?vue&type=script&lang=js"
export * from "./addForumTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports